<template>
  <div class="flex flex-col min-h-screen">
    <!-- Top Header -->
    <global-top-header />

    <!-- Logo Section -->
    <div class="flex justify-center mt-10 sm:mt-16 mb-4 px-4">
      <img
        :src="require('@/assets/logo.png')"
        alt="Logo"
        class="h-20 sm:h-32 w-auto"
      />
    </div>

    <!-- Input Section -->
    <div class="flex-grow flex flex-col items-center mt-8 sm:mt-16 px-4 w-full">
      <div class="w-full max-w-2xl">
        <!-- Form -->
        <form
          @submit.prevent="trackingCheckerHandler"
          class="flex flex-col gap-4 sm:flex-row"
        >
          <input
            v-model.trim="inputTrackingNumber"
            type="text"
            placeholder="Enter tracking number"
            class="w-full h-14 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-gray-200"
            :disabled="loading"
          />

          <button
            type="submit"
            :disabled="loading || !inputTrackingNumber"
            class="h-14 w-full sm:w-32 bg-secondary text-white font-semibold rounded-lg transition duration-200 flex items-center justify-center"
          >
            <template v-if="!loading">Track</template>
            <template v-else>
              <svg
                class="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
            </template>
          </button>
        </form>

        <!-- Error Message -->
        <div
          v-if="ifValidTransactionNumber"
          class="mt-4 rounded-lg bg-red-50 border border-red-300 text-red-800 px-4 py-3 text-sm"
        >
          No record found. Please ensure the tracking number is entered
          correctly.
        </div>
      </div>
    </div>

    <!-- Footer -->
    <global-footer />
  </div>
</template>

<script>
import { inject, ref } from "vue";
import { useRouter } from "vue-router";

export default {
  setup() {
    const axios = inject("$axios");
    const router = useRouter();

    const inputTrackingNumber = ref("");
    const ifValidTransactionNumber = ref(false);
    const loading = ref(false);

    const showError = () => {
      ifValidTransactionNumber.value = true;
      setTimeout(() => {
        ifValidTransactionNumber.value = false;
      }, 3000);
    };

    const trackingCheckerHandler = async () => {
      const trackingNumber = inputTrackingNumber.value.trim();

      if (!trackingNumber) return showError();

      loading.value = true;
      try {
        const { data } = await axios.get("/public/tracking", {
          params: { search: trackingNumber },
        });

        setTimeout(() => {
          if (data.result) {
            router.push(`/tracking/${trackingNumber}`);
          } else {
            showError();
          }
        }, 3000);
      } catch (error) {
        console.error("Tracking check failed:", error);
        showError();
      } finally {
        setTimeout(() => {
          loading.value = false;
        }, 3000);
      }
    };

    return {
      inputTrackingNumber,
      ifValidTransactionNumber,
      trackingCheckerHandler,
      loading,
    };
  },
};
</script>
